<template>
  <div class="pageError">
    {{ errorType }}
    <div class="session-expired">
      <img src="@/assets/images/404.webp" />
      <h2>{{ $t('Oops') }}</h2>
      <p class="description">{{ $t('Your session expired, please login again.') }}</p>
      <button v-if="withCommission" class="go-to-login" @click="goToLoginPage">{{ $t('Go to login page') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'session-expired',
  props: {
    errorType: {
      type: String,
      Required: true,
    },
  },
  computed: {
    ...mapGetters({
      withCommission: 'general/withCommission',
    }),
  },
  methods: {
    goToLoginPage() {
      if (window.parent) {
        window.parent.postMessage('Logout', '*');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pageError {
  width: 100%;
  height: 100%;
  background-color: #000;

  p {
    margin: 0;

    &.description {
      font-size: 16px;
      font-weight: 600;
      line-height: 0.75;
      letter-spacing: normal;
      text-align: center;
      color: #b8d0ed;
    }
  }

  .session-expired {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    img {
      width: 124px;
      height: 124px;
      margin-bottom: 32px;

      @include phone-only {
        width: 86px;
        height: 86px;
        margin-bottom: 30px;
      }
    }

    h2 {
      margin: 0 0 19px;
      font-size: 24px;
      font-weight: 600;
      line-height: 0.9;
      letter-spacing: normal;
      text-align: center;
      color: #ceb57d;
      text-transform: uppercase;
    }

    p {
      text-transform: uppercase;
    }
  }
  button.go-to-login {
    @include load-more;
    width: auto;
    padding: 8px 12px;
    margin-top: 20px;
  }
}
</style>
